const DEFAULT_PRIMARY = '#006bc2';
const REF_LIGHT_TINT = '#e6f0ff';
const REF_LIGHTER_TINT = '#f0f7ff';
const REF_DARK_TINT = '#1e3a5f';
const REF_DARK_LIGHTER_TINT = '#162842';
const REF_DARK_TINT_TEXT = '#7eb8e8';
const REF_LIGHT_STATUS_BG = '#c8d7e1';
const REF_LIGHT_STATUS_TEXT = '#003d66';
export function normalizePrimaryHex(input) {
  const raw = input == null ? '' : String(input).trim();
  if (!raw) return DEFAULT_PRIMARY;
  let h = raw.replace(/^#/, '');
  if (h.length === 3 && /^[0-9a-fA-F]{3}$/.test(h)) {
    h = h.split('').map(c => c + c).join('');
  }
  if (h.length === 6 && /^[0-9a-fA-F]{6}$/.test(h)) {
    return `#${h.toLowerCase()}`;
  }
  return DEFAULT_PRIMARY;
}
export function getPrimaryHoverHex(primaryHex) {
  const h = normalizePrimaryHex(primaryHex).replace('#', '');
  const r = parseInt(h.slice(0, 2), 16) || 0;
  const g = parseInt(h.slice(2, 4), 16) || 0;
  const b = parseInt(h.slice(4, 6), 16) || 0;
  const hoverR = Math.max(0, Math.floor(r * 0.85));
  const hoverG = Math.max(0, Math.floor(g * 0.85));
  const hoverB = Math.max(0, Math.floor(b * 0.85));
  return `#${hoverR.toString(16).padStart(2, '0')}${hoverG.toString(16).padStart(2, '0')}${hoverB.toString(16).padStart(2, '0')}`;
}
function parseHex(hex) {
  const h = (hex || '').replace('#', '').trim();
  if (h.length !== 6) return null;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return null;
  return {
    r,
    g,
    b
  };
}
function toHex(r, g, b) {
  const R = Math.max(0, Math.min(255, Math.round(r)));
  const G = Math.max(0, Math.min(255, Math.round(g)));
  const B = Math.max(0, Math.min(255, Math.round(b)));
  return `#${R.toString(16).padStart(2, '0')}${G.toString(16).padStart(2, '0')}${B.toString(16).padStart(2, '0')}`;
}
export function getPrimaryLightTint(primaryHex) {
  const c = parseHex(primaryHex || DEFAULT_PRIMARY);
  if (!c) return REF_LIGHT_TINT;
  const r = c.r * 0.1 + 255 * 0.9;
  const g = c.g * 0.1 + 255 * 0.9;
  const b = c.b * 0.1 + 255 * 0.9;
  return toHex(r, g, b);
}
export function getPrimaryLighterTint(primaryHex) {
  const c = parseHex(primaryHex || DEFAULT_PRIMARY);
  if (!c) return REF_LIGHTER_TINT;
  const r = c.r * 0.05 + 255 * 0.95;
  const g = c.g * 0.05 + 255 * 0.95;
  const b = c.b * 0.05 + 255 * 0.95;
  return toHex(r, g, b);
}
export function getPrimaryDarkTint(primaryHex) {
  const c = parseHex(primaryHex || DEFAULT_PRIMARY);
  if (!c) return REF_DARK_TINT;
  const r = c.r * 0.262 + 30;
  const g = c.g * 0.262 + 30;
  const b = c.b * 0.335 + 30;
  return toHex(r, g, b);
}
export function getPrimaryDarkLighterTint(primaryHex) {
  const c = parseHex(primaryHex || DEFAULT_PRIMARY);
  if (!c) return REF_DARK_LIGHTER_TINT;
  const r = c.r * 0.262 + 22;
  const g = c.g * 0.168 + 22;
  const b = c.b * 0.227 + 22;
  return toHex(r, g, b);
}
export function getPrimaryDarkTintText(primaryHex) {
  const c = parseHex(primaryHex || DEFAULT_PRIMARY);
  if (!c) return REF_DARK_TINT_TEXT;
  const r = Math.min(255, c.r * 0.4 + 255 * 0.6);
  const g = Math.min(255, c.g * 0.4 + 255 * 0.6);
  const b = Math.min(255, c.b * 0.4 + 255 * 0.6);
  return toHex(r, g, b);
}
export function getPrimaryLightStatusBg(primaryHex) {
  const c = parseHex(primaryHex || DEFAULT_PRIMARY);
  if (!c) return REF_LIGHT_STATUS_BG;
  const r = c.r * 0.25 + 255 * 0.75;
  const g = c.g * 0.25 + 255 * 0.75;
  const b = c.b * 0.25 + 255 * 0.75;
  return toHex(r, g, b);
}
export function getPrimaryLightStatusText(primaryHex) {
  const c = parseHex(primaryHex || DEFAULT_PRIMARY);
  if (!c) return REF_LIGHT_STATUS_TEXT;
  const r = c.r * 0.4;
  const g = c.g * 0.4;
  const b = c.b * 0.4;
  return toHex(r, g, b);
}
